import { render, staticRenderFns } from "./WebFamousPediaTopBar.vue?vue&type=template&id=3b215d52&"
import script from "./WebFamousPediaTopBar.vue?vue&type=script&lang=js&"
export * from "./WebFamousPediaTopBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports